import { Flowsheet } from "@/Flowsheets/Models/Flowsheet";
import { FlowsheetSummary } from "@/Flowsheets/Models/FlowsheetSummary";
import { FlowsheetTemplate } from "@/Flowsheets/Models/FlowsheetTemplate";

/**
 * Maps a Flowsheet object and its template to a FlowsheetSummary object.
 *
 * @param flowsheet - The Flowsheet object containing flowsheet data.
 * @param template - The FlowsheetTemplate object associated with the flowsheet.
 * @returns A new FlowsheetSummary object with the mapped data.
 */
function flowsheetToFlowsheetSummary(flowsheet: Flowsheet, template: FlowsheetTemplate): FlowsheetSummary {
    return new FlowsheetSummary({
        Id: flowsheet.Id,
        EncounterId: flowsheet.EncounterId,
        ApprovalDate: flowsheet.ApprovalDate,
        ApprovedByEmployeeId: flowsheet.ApprovedByEmployeeId,
        Template: template,
        CreationDate: flowsheet.CreationDate,
        CreatedByEmployeeId: flowsheet.CreatedByEmployeeId
    });
}

export default flowsheetToFlowsheetSummary;
